import { render, staticRenderFns } from "./BulkDotModeUpdate.vue?vue&type=template&id=264e6db5&"
import script from "./BulkDotModeUpdate.vue?vue&type=script&lang=js&"
export * from "./BulkDotModeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports